// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Xo","placeholder":"e_Yo","embed":"e_Zo"};